// extracted by mini-css-extract-plugin
export default {"productLink":"ProductLink_productLink__Z4w+Q"};